import { api } from "./api_core";

export const liuyaoApi = {
  // 保存六爻排盘
  saveLiuyaoChart: async (data) => {
    try {
      const response = await api.post("/liuyao/save", data);
      // 适配后端返回: 可能是 { liuyao_chart_id: ... } 或 { success: true, data: ... }
      const id = response.data.liuyao_chart_id || response.data.id;
      return { success: true, id: id, data: response.data, status: response.status };
    } catch (error) {
      return {
        success: false,
        status: error.response?.status,
        error: error.response?.data?.error || "保存失败",
      };
    }
  },

  // 获取用户对卦例的互动状态
  getInteractionStatus: async (chartId) => {
    try {
      const response = await api.get(`/public/liuyao/chart/${chartId}/interaction-status`);
      return { success: true, data: response.data.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "获取状态失败",
      };
    }
  },
};